import React from "react";
import ListingLoader from "../../component/LoaderTemplate";
import NoDataFound from "../../component/NoDataFound";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import IssueList from "../issueList/IssueTile";
import { IssueListingTemplate } from "../../component/LoadersTemplate";

export default ({
  issueList,
  isLoading,
  paginationNo,
  permission,
  callApiOnSuccess,
  filterArray,
  handleClickStatus,
  isIssueList
}) => {
  return (
    <div>
      {isLoading === STATUS.LOADING ? (
        <ListingLoader
          parentClass="loader-project-list"
          times={10}
          height={65}
          children={<IssueListingTemplate />}
        />
      ) : isLoading === STATUS.SUCCESS && isValidArray(issueList) ? (
        issueList.map((issueDto, index) => (
          <IssueList
            permission={permission}
            issueDetails={issueDto}
            key={index}
            paginationNo={paginationNo}
            callApiOnSuccess={callApiOnSuccess}
            filterArray={filterArray}
            handleClickStatus={handleClickStatus}
            isIssueList={isIssueList}
          />
        ))
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};
